import { Chip } from "@mui/material";
import genericStyles from "../../Styles/genericStyles.module.css";
import { ETableEditAction } from "../../Utils/Enums";
import { endpoints, localUrlEnum } from "../../Utils/UrlEnum";
import { formatDate } from "../../Utils/Utils";
import { Vocabulary } from "../../Utils/Vocabulary";
import MUIDataTableCustomStyle from "../MUIDataTableCustomStyle";
import SchoolIcon from "@mui/icons-material/School";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { useNavigate } from "react-router-dom";

/**
 * A component that renders a table with all the recommendations.
 * The table is editable and uses the MUIDataTableCustomStyle component.
 * The data is fetched from the recommendations endpoint.
 *
 * @returns a JSX element that renders a table with all the recommendations
 */
export default function RecommendationsTable() {
  const navigate = useNavigate();

  /**
   * The columns of the table
   */
  const columns = [
    {
      label: Vocabulary.id,
      name: "incrementId",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.CNP,
      name: "clientCNP",
      options: {
        sort: true,
        customBodyRender: (value: any) => {
          return (
            <div style={{ color: "#337ab7", fontWeight: "bold" }}>{value}</div>
          );
        },
        exportValue: (value: any) => value || "",
      },
    },
    {
      label: Vocabulary.client,
      name: "clientName",
      options: {
        sort: true,
        customBodyRender: (value: any) => {
          return (
            <div style={{ color: "#337ab7", fontWeight: "bold" }}>{value}</div>
          );
        },
        exportValue: (value: any) => value || "",
      },
    },
    {
      label: Vocabulary.recomendedBy,
      name: "recommendationData",
      options: {
        sort: true,
        customBodyRender: (rowData: any) => {
          return <>{rowData?.name}</>;
        },
        exportValue: (rowData: any) => rowData?.name || "",
      },
    },
    {
      label: Vocabulary.productType,
      name: "product",
      options: {
        sort: true,
        sortField: "product.name",
        customBodyRender: (rowData: any) => {
          return (
            <Chip
              icon={
                rowData?.isCertificate ? (
                  <SchoolIcon fontSize="small" style={{ color: "ed5565" }} />
                ) : (
                  <CreditCardIcon
                    fontSize="small"
                    style={{ color: "#f8ac59" }}
                  />
                )
              }
              color={"default"}
              label={rowData?.name}
              style={{ padding: 5 }}
            />
          );
        },
        exportValue: (rowData: any) => rowData?.name || "",
      },
    },
    {
      label: Vocabulary.reward,
      name: "recommendationValue",
      options: {
        sort: true,
      },
    },
    {
      label: Vocabulary.price,
      name: "product",
      options: {
        sort: true,
        sortField: "product.price",
        customBodyRender: (rowData: any) => {
          return <>{rowData?.price}</>;
        },
        exportValue: (rowData: any) => rowData?.price ?? "",
      },
    },
    {
      label: Vocabulary.workPoint,
      name: "workPointName",
      options: {
        sort: true,
      },
    },
    {
      label: Vocabulary.instructor,
      name: "instructorName",
      options: {
        sort: true,
      },
    },
    {
      label: Vocabulary.createdAt,
      name: "createdAt",
      options: {
        sort: true,
        customBodyRender: (date: Date) => {
          return (
            <div style={{ color: "#ed5565", fontWeight: "bold" }}>
              {" "}
              {formatDate(date, "yyyy-MM-dd HH:mm")}
            </div>
          );
        },
        exportValue: (date: Date) => date ? formatDate(date, "yyyy-MM-dd HH:mm") : "",
      },
    },
  ];

  return (
    <div className={genericStyles.mainContainer}>
      <MUIDataTableCustomStyle
        title={Vocabulary.refferals}
        onEditAction={ETableEditAction.NONE}
        CRUDEndPoint={endpoints.recommendations}
        columns={columns}
        onRowClick={(rowData: any) => {
          navigate(`${localUrlEnum.order}/${rowData?.order_id}`);
        }}
        hideEditButton
        hideAddButton
        hideDeleteButton
        columnsWithCustomSort={["product"]}
        showPrintButton
        showDownloadButton
        exportWithTimestamp
      />
    </div>
  );
}
